import React from 'react'
import { useRouter } from 'next/router'

import { EbookProfileCardProps, EbookProfileCardAcceptProps } from './interface'

export function withEbookProfileCard(
  Component: React.FC<EbookProfileCardProps>
) {
  function WithEbookProfileCard({
    redirect,
    ...props
  }: EbookProfileCardAcceptProps) {
    const router = useRouter()

    function handleViewClick() {
      if (redirect) {
        router.push(redirect)
      }
    }

    const componentProps = {
      ...props,
      handleViewClick,
    }

    return <Component {...componentProps} />
  }

  return WithEbookProfileCard
}
